export const DICTIONARY_VALUE_EDIT_PATH = "/dictionaries/:dictionary/:id";
